import "@/pages/vendors/vendor.jqueryui.autocomplete";
import "../Styles/main.scss";
import "./index.scss";
import "../../components/cmsShared";
import { UrlUtils } from "@/pages/base/urlUtils";
import { cmsGlobal } from "@/common/fhtGlobalEnv";
import { KEY_VALUES } from "@/consts";
import { ProductApiClient } from "@/api";
import { cmsProductSearchUrl } from "@/pages/base/urls";

const productApi = new ProductApiClient("");

//搜索
$(function () {
	const $mask = $('<div class="mask-on-search"></div>').appendTo(document.body);
	const $searchBox = $(".mobile-search-box");
	const $searchBoxInput = $(".mobile-search-box__input");

	const $searchClose = $(".mobile-search-box__close");
	function offSearch() {
		$searchBox.hide();
		$mask.hide();
	}
	$searchClose.on("click", offSearch);

	function search() {
		offSearch();
		const q = $(".mobile-search-box__input").val() as string;
		const templateId = UrlUtils.GetQueryStringByKey("templateId");
		let searchBoxUrl = cmsProductSearchUrl(cmsGlobal.Cms.CompanyId, q);
		if (templateId) {
			searchBoxUrl = UrlUtils.UpdateQueryString("templateId", templateId, searchBoxUrl);
		}
		location.href = searchBoxUrl;
	}

	$searchBoxInput.on("keyup", function (event) {
		//todo @jiannan to verify on mobile devices
		if (event.key === KEY_VALUES.ENTER) {
			search();
		}
	});
});

$(function () {
	// eslint-disable-next-line fht-eslint-rules/restricted-jquery-methods
	const $searchBoxInput = $(".search-box__keyword");
	const $searchBtn = $(".search-box__btn");
	$searchBoxInput.on("keypress", function (e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			// eslint-disable-next-line fht-eslint-rules/restricted-jquery-methods
			$searchBtn.click();
		}
	});

	$searchBtn.click(function () {
		const q = $("#Q").val();
		location.href = cmsProductSearchUrl(cmsGlobal.Cms.CompanyId, q);
	});

	if (!cmsGlobal.Cms.IsCustomDomain) {
		const $searchInput = $(".search-box__keyword");
		const searchResultClass = "search-result";
		$searchInput.focus(function () {
			$searchInput.autocomplete("search", "");
		});
		//autocomplete
		$searchInput.autocomplete({
			minLength: 0,
			appendTo: ".search-box",
			classes: {
				"ui-autocomplete": searchResultClass,
			},
			html: true,
			select: function (event, ui) {
				const inputVal = ui.item.value;
				console.log(inputVal);
				$searchInput.val(inputVal);
				// eslint-disable-next-line fht-eslint-rules/restricted-jquery-methods
				$searchBtn.click();
			},
			source: async function (request, response) {
				const term = request.term;
				const data: [number, string] = [cmsGlobal.Cms.CompanyId, term];
				if (term !== "") {
					const res = await productApi.autocomplete(...data);
					if (res) {
						const options = res.map((item) => ({
							label: item.Value,
							value: item.Value!.replace('<em class="keyword">', "").replace("</em>", ""),
						})) as JQueryUIAutocompleteOptionType[];
						response(options);
					} else {
						response();
					}
				}
			},
		});
	}
});
